'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Popover = require('./Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tip = function (_Component) {
  _inherits(Tip, _Component);

  function Tip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tip.__proto__ || Object.getPrototypeOf(Tip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovering: false
    }, _this.setHovering = _underscore2.default.debounce(function (hovering) {
      _this.setState({ hovering: hovering });
    }, 100), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tip, [{
    key: 'renderTip',
    value: function renderTip() {
      var tip = this.props.tip;


      return _react2.default.createElement(
        'div',
        { className: 'pd-sm' },
        tip
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var hovering = this.state.hovering;
      var children = this.props.children;


      return _react2.default.createElement(
        _Popover2.default,
        { content: this.renderTip(), open: hovering },
        _react2.default.createElement(
          'span',
          { onMouseEnter: function onMouseEnter() {
              return _this2.setHovering(true);
            }, onMouseLeave: function onMouseLeave() {
              return _this2.setHovering(false);
            } },
          children
        )
      );
    }
  }]);

  return Tip;
}(_react.Component);

Tip.propTypes = {
  tip: _react.PropTypes.node.isRequired
};

Tip.demo = function () {
  return _react2.default.createElement(
    _reactDemo2.default,
    { props: { tip: _reactDemo.props.string('This is the content of the tip') } },
    function (props, update) {
      return _react2.default.createElement(
        Tip,
        props,
        _react2.default.createElement(
          'span',
          null,
          'This is the child of the tip. Hover to see the tip.'
        )
      );
    }
  );
};

exports.default = Tip;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/Tip.js
// module id = 410
// module chunks = 0